import { useState, useEffect } from "react";
import { API } from "./api";

export default function Categories() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [editing, setEditing] = useState(null);

  const load = () => API.listCategories().then(setItems);
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!name.trim()) return;
    if (editing) await API.updateCategory(editing, { name, description: desc });
    else await API.createCategory({ name, description: desc });
    setName(""); setDesc(""); setEditing(null); load();
  };

  return (
    <div data-testid="page-categories">
      <h1>Categories</h1>
      <div className="panel row-form">
        <input placeholder="Category name" value={name} onChange={(e) => setName(e.target.value)} data-testid="cat-name" />
        <input placeholder="Description (optional)" value={desc} onChange={(e) => setDesc(e.target.value)} />
        <button className="btn primary" onClick={save} data-testid="cat-save">{editing ? "Update" : "+ Add Category"}</button>
        {editing && <button className="btn ghost" onClick={() => { setEditing(null); setName(""); setDesc(""); }}>Cancel</button>}
      </div>

      <div className="panel">
        <table className="tbl">
          <thead><tr><th>Name</th><th>Slug</th><th>Description</th><th style={{ width: 140 }}></th></tr></thead>
          <tbody>
            {items.length === 0 ? <tr><td colSpan={4} className="empty">No categories yet.</td></tr> :
              items.map((c) => (
                <tr key={c.id}>
                  <td><b>{c.name}</b></td>
                  <td><code>{c.slug}</code></td>
                  <td>{c.description}</td>
                  <td>
                    <button className="link" onClick={() => { setEditing(c.id); setName(c.name); setDesc(c.description || ""); }}>Edit</button>
                    <button className="link danger" onClick={async () => { await API.deleteCategory(c.id); load(); }}>Delete</button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
